import { render, staticRenderFns } from "./DealsControl.vue?vue&type=template&id=184b198c&"
import script from "./DealsControl.vue?vue&type=script&lang=js&"
export * from "./DealsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports